import React, { useState, useImperativeHandle } from 'react';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';

const animatedComponents = makeAnimated();

export const SelectAno = React.forwardRef(({ onChange }, ref) => {
  const [selectedOptions, setSelectedOptions] = useState([]);

  const options = [];
  const currentYear = new Date().getFullYear();

  for (let year = currentYear; year >= 1985; year--) {
    options.push({ value: year, label: year.toString() });
  }

  const handleSelectionChange = (selected) => {
    setSelectedOptions(selected);
    onChange(selected);
  };

  const resetSelectAno = () => {
    setSelectedOptions([]);
  };

  useImperativeHandle(ref, () => ({
    resetSelectAno: resetSelectAno
  }));

  return (
    <div className='Select'>
      <Select
        closeMenuOnSelect={false}
        components={animatedComponents}
        isMulti
        value={selectedOptions}
        options={options}
        onChange={handleSelectionChange}
        placeholder={<div>Selecione...</div>}
      />
    </div>
  );
});
